var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "update-w3-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("whatsapp_business_api.channelName"))),
              ]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  placeholder: _vm.$t("whatsapp_business_api.channelName"),
                  name: "channelName",
                },
                model: {
                  value: _vm.clone.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "name", $$v)
                  },
                  expression: "clone.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c(
                "div",
                { staticClass: "mt-1 mb-1" },
                [
                  _c("a-switch", {
                    attrs: { checked: !!_vm.clone.forward.story },
                    on: { click: _vm.toggleChatbot },
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "👉 " +
                        _vm._s(_vm.$t("whatsapp_business_api.forwardToChatbot"))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("label", [
                _vm._v(_vm._s(_vm.$t("whatsapp_business_api.forwarding"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  attrs: {
                    defaultValue: null,
                    notFoundContent: _vm.$t(
                      "whatsapp_business_api.forwardLiveAgents"
                    ),
                    disabled: !_vm.showStories,
                  },
                  on: { change: _vm.handleStoryChange },
                  model: {
                    value: _vm.clone.forward.story,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.forward, "story", $$v)
                    },
                    expression: "clone.forward.story",
                  },
                },
                [
                  _c(
                    "a-select-option",
                    { attrs: { selected: true, value: null } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("whatsapp_business_api.forwardLiveAgents")
                          )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.stories, function (story) {
                    return _c(
                      "a-select-option",
                      { key: story._id, attrs: { value: story._id } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(story.title) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("message.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.update")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }